import { Action } from '@ngrx/store';


export enum ESOActions {
    GetAllSOs = '[SO] Get All SO',
    GetAllSODetails = '[SO] Set All SO Details',
    AddSO = '[SO] Add SO',
    EditSO = '[SO] Edit SO',
    SetSOSuccess = 'Set SO Success',
    SetSOError = 'Set SO Error',
    AddDispatchOrder = '[SO] Add Dispatch Order',
    GetSOCode = '[SO] Get SO Code',
    GetSOCodeSuccess = '[SO] Get SO Code Success',
    GetSOById = '[SO] Get SO By Id',
    GetSOByIdSuccess = '[SO] Set SO By Id Success',
    GetSOByIdError = '[SO] Set SO By Id Error',
    GetInActiveStatus = '[SO] InActive Status',
    GetInActiveStatusSuccess = '[SO] InActive Status Success',
    GetInActiveStatusError = '[SO] InActive Status Error',
    CloseSO = '[SO] Close SO',
    GetCloseSOSuccess = '[SO] Close SO Success',
    GetCloseSOError = '[] Close SO Error',
    GetForcastSales = '[Forecast] Get Forcast Sales',
    GetForcastSalesSuccess = '[Forecast] Get Forcast Sales Success',
    GetForcastSalesError = '[] Get Forcast Sales Error',
    AddForcastSales = '[Forecast] Add Forcast Sales',
    GetaddForcastSalesSuccess = '[Forecast] Get Add Forcast Sales Success',
    GetaddForcastSalesError = '[] Get Add Forcast Sales Error',
    EditForcastSales = '[Forecast] Edit Forcast Sales',
    GeteditForcastSalesSuccess = '[Forecast] Get Edit Forcast Sales Success',
    GeteditForcastSalesError = '[] Get Edit Forcast Sales Error',
    GetSOsByCustomerId='[SO] Get SOs By CustomerId',
    GetSOsByCustomerIdSuccess='[SO] Get SOs By CustomerId Success',
    GetSOsByCustomerIdError='[] Get SOs By CustomerId Error',





     //dispatch orders

     GetDONumber = '[DispatchOrders] Get Dispath Orders InternalCode',
     GetDONumberSuccess = '[DispatchOrders] Set Dispath Orders InternalCode Success',
     GetDONumberError = '[DispatchOrders] Set Dispath Orders InternalCode Error',
     AddDO = '[DispatchOrders] Add Dispatch Order',
     GetAddDOSuccess = '[DispatchOrders] Set Add Dispatch Order Success',
     GetAddDOError = '[DispatchOrders] Set Add Dispatch Order Error',
     GetAllDOs = '[dispatchOrders] Get All DOs',
     GetAllDOsSuccess = '[dispatchOrders] Get All DOs success',
     GetAllDOsError = '[] Get All DOs Error',
     GetDOsByPS = '[dispatchOrders] Get DOs By PS',
     GetDOsByPSSuccess = '[dispatchOrders] Get DOs By PS Success',
     GetDOsByPSError = '[] Get DOs By PS Error',
     GetDOdetails = '[dispatchOrders] Get DO details',
     GetDOdetailsSuccess = '[dispatchOrders] Get DO details success',
     GetDOdetailsError = '[] Get DO details Error',
     AddPackSlips = '[dispatchOrders] Add Pack Slips',
     GetAddPackSlipsSuccess = '[dispatchOrders] Add Pack Slips success',
     GetAddPackSlipsError = '[] Add Pack Slips Error',
     GetAllPackSlips = '[dispatchOrders] Get All PackSlips',
     GetAllPackSlipsSuccess = '[dispatchOrders] Get All PackSlips Success',
     GetAllPackSlipsError = '[] Get All PackSlipsError',
     EditpackSlips = '[dispatchOrders] Edit Pack Slips',
     GetEditpackSlipsSuccess = '[dispatchOrders] Edit Pack Slips Success',
     GetEditpackSlipsError = '[] Edit Pack Slips Error',
     GetRPsBasedOnMonth = '[RPs] Get RPs Based on Month',
     GetRPsBasedOnMonthSuccess = '[RPs] Get RPs Based on Month Success',
     GetRPsBasedOnMonthError = '[] Get RPs Based on Month Error',
     GetDosByFormulaId='[dispatchOrders] Get Dos By Formula Id',
     GetDosByFormulaIdSuccess='[dispatchOrders] Get Dos By Formula Id Success',
     GetDosByFormulaIdError='[] Get Dos By Formula Id Error',
     InActivatePs='[dispatchOrders] InActivate Ps',
     InActivatePsSuccess='[dispatchOrders] InActivate Ps Success',
     InActivatePsError='[] InActivate Ps Error',
     cancelDo='[dispatchOrders] Cancel Do',
     cancelDoSuccess='[dispatchOrders] Cancel Do Success',
     cancelDoError='[] cancel Do Error'
}

export class GetDONumber implements Action {
  public readonly type = ESOActions.GetDONumber;
  constructor(public payload: any) {}  
}

export class GetDONumberSuccess implements Action {
  public readonly type = ESOActions.GetDONumberSuccess;
  constructor(public payload: any) {}  
}

export class GetDONumberError implements Action {
  public readonly type = ESOActions.GetDONumberError;
  constructor(public payload: any) {}  
}

export class AddDO implements Action {
  public readonly type = ESOActions.AddDO;
  constructor(public payload: any) {}  
}

export class GetAddDOSuccess implements Action {
  public readonly type = ESOActions.GetAddDOSuccess;
  constructor(public payload: any) {}  
}

export class GetAddDOError implements Action {
  public readonly type = ESOActions.GetAddDOError;
  constructor(public payload: any) {}  
}

 
export class AddDispatchOrder implements Action{
    public readonly type = ESOActions.AddDispatchOrder;
    constructor(public payload: any){}
}

export class GetAllSOs implements Action {
    public readonly type = ESOActions.GetAllSOs;
    constructor(public payload: any) {}
}

export class GetAllSODetails implements Action {
    public readonly type = ESOActions.GetAllSODetails;
    constructor(public payload: any) {
    }
}

export class AddSO implements Action {
    public readonly type = ESOActions.AddSO;
    constructor(public payload: any) {
    }
}
export class EditSO implements Action {
    public readonly type = ESOActions.EditSO;
    constructor(public payload: any) {
    }
}

export class SetSOSuccess implements Action {
    public readonly type = ESOActions.SetSOSuccess;
    constructor(public payload: any, public from: any) {
    }
}

export class SetSOError implements Action {
    public readonly type = ESOActions.SetSOError;
    constructor(public payload: any, public from: any) {
    }
}

export class GetSOCode implements Action {
    public readonly type = ESOActions.GetSOCode;
    constructor(public payload: any) {        
    }
}

export class GetSOCodeSuccess implements Action {
    public readonly type = ESOActions.GetSOCodeSuccess;
    constructor(public payload: any) {        
    }
}

  export class  GetSOById implements Action {
    public readonly type = ESOActions.GetSOById;
    constructor(public payload: any) {}
  }

  export class  GetSOByIdSuccess implements Action {
    public readonly type = ESOActions.GetSOByIdSuccess;
    constructor(public payload: any) {}
  }

  export class  GetSOByIdError implements Action {
    public readonly type = ESOActions.GetSOByIdError;
    constructor(public payload: any) {}
  }
  export class GetInActiveStatus implements Action {
    public readonly type = ESOActions.GetInActiveStatus;
    constructor (public payload: any, public param: any){}
}
export class GetInActiveStatusSuccess implements Action {
    public readonly type = ESOActions.GetInActiveStatusSuccess;
    constructor (public payload: any){}
}
export class GetInActiveStatusError implements Action {
    public readonly type = ESOActions.GetInActiveStatusError;
    constructor (public payload: any){}
}
export class CloseSO implements Action {
  public readonly type = ESOActions.CloseSO;
  constructor (public payload: any, public param: any){}
}
export class GetCloseSOSuccess implements Action {
  public readonly type = ESOActions.GetCloseSOSuccess;
  constructor (public payload: any){}
}
export class GetCloseSOError implements Action {
  public readonly type = ESOActions.GetCloseSOError;
  constructor (public payload: any){}
}
      //dispatch orders
      export class GetAllDOs implements Action {
        public readonly type = ESOActions.GetAllDOs;
        constructor(public payload: any) {}

      }
      export class GetAllDOsSuccess implements Action {
        public readonly type = ESOActions.GetAllDOsSuccess;
        constructor(public payload: any) {}

      }
      export class GetAllDOsError implements Action {
        public readonly type = ESOActions.GetAllDOsError;
        constructor(public payload: any) {}

      }
      
      export class GetDOsByPS implements Action {
        public readonly type = ESOActions.GetDOsByPS;
        constructor(public payload: any) {}

      }
      export class GetDOsByPSSuccess implements Action {
        public readonly type = ESOActions.GetDOsByPSSuccess;
        constructor(public payload: any) {}

      }
      export class GetDOsByPSError implements Action {
        public readonly type = ESOActions.GetDOsByPSError;
        constructor(public payload: any) {}

      }
      export class GetDOdetails implements Action {
        public readonly type = ESOActions.GetDOdetails;
        constructor(public payload: any) {}

      }
      
      export class GetDOdetailsSuccess implements Action {
        public readonly type = ESOActions.GetDOdetailsSuccess;
        constructor(public payload: any) {}

      }
      export class GetDOdetailsError implements Action {
        public readonly type = ESOActions.GetDOdetailsError;
        constructor(public payload: any) {}

      }
      export class AddPackSlips implements Action {
        public readonly type = ESOActions.AddPackSlips;
        constructor(public payload: any) {}

      }
      export class GetAddPackSlipsSuccess implements Action {
        public readonly type = ESOActions.GetAddPackSlipsSuccess;
        constructor(public payload: any) {}

      }
      export class GetAddPackSlipsError implements Action {
        public readonly type = ESOActions.GetAddPackSlipsError;
        constructor(public payload: any) {}

      }
      export class GetAllPackSlips implements Action {
        public readonly type = ESOActions.GetAllPackSlips;
        constructor(public payload: any) {}

      }
      export class GetAllPackSlipsSuccess implements Action {
        public readonly type = ESOActions.GetAllPackSlipsSuccess;
        constructor(public payload: any) {}

      }
      export class GetAllPackSlipsError implements Action {
        public readonly type = ESOActions.GetAllPackSlipsError;
        constructor(public payload: any) {}

      }
      export class EditpackSlips implements Action {
        public readonly type = ESOActions.EditpackSlips;
        constructor(public payload: any) {}

      }
      export class GetEditpackSlipsSuccess implements Action {
        public readonly type = ESOActions.GetEditpackSlipsSuccess;
        constructor(public payload: any) {}

      }
      export class GetEditpackSlipsError implements Action {
        public readonly type = ESOActions.GetEditpackSlipsError;
        constructor(public payload: any) {}

      }
      export class GetRPsBasedOnMonth implements Action {
        public readonly type = ESOActions.GetRPsBasedOnMonth;
        constructor(public payload: any) {}

      }
      export class GetRPsBasedOnMonthSuccess implements Action {
        public readonly type = ESOActions.GetRPsBasedOnMonthSuccess;
        constructor(public payload: any) {}

      }
      export class GetRPsBasedOnMonthError implements Action {
        public readonly type = ESOActions.GetRPsBasedOnMonthError;
        constructor(public payload: any) {}

      }
      export class GetForcastSales implements Action {
        public readonly type = ESOActions.GetForcastSales;
        constructor(public payload: any) {}

      }
      export class GetForcastSalesSuccess implements Action {
        public readonly type = ESOActions.GetForcastSalesSuccess;
        constructor(public payload: any) {}

      }
      export class GetForcastSalesError implements Action {
        public readonly type = ESOActions.GetForcastSalesError;
        constructor(public payload: any) {}

      }
      export class AddForcastSales implements Action {
        public readonly type = ESOActions.AddForcastSales;
        constructor(public payload: any) {}

      }
      export class GetaddForcastSalesSuccess implements Action {
        public readonly type = ESOActions.GetaddForcastSalesSuccess;
        constructor(public payload: any) {}

      }
      export class GetaddForcastSalesError implements Action {
        public readonly type = ESOActions.GetaddForcastSalesError;
        constructor(public payload: any) {}

      }
      export class EditForcastSales implements Action {
        public readonly type = ESOActions.EditForcastSales;
        constructor(public payload: any) {}

      }
      export class GeteditForcastSalesSuccess implements Action {
        public readonly type = ESOActions.GeteditForcastSalesSuccess;
        constructor(public payload: any) {}

      }
      export class GeteditForcastSalesError implements Action {
        public readonly type = ESOActions.GeteditForcastSalesError;
        constructor(public payload: any) {}

      }
      export class GetDosByFormulaId implements Action {
        public readonly type = ESOActions.GetDosByFormulaId;
        constructor(public payload: any) {}

      }
      export class GetDosByFormulaIdSuccess implements Action {
        public readonly type = ESOActions.GetDosByFormulaIdSuccess;
        constructor(public payload: any) {}

      }
      export class GetDosByFormulaIdError implements Action {
        public readonly type = ESOActions.GetDosByFormulaIdError;
        constructor(public payload: any) {}

      }
      export class InActivatePs implements Action {
        public readonly type = ESOActions.InActivatePs;
        constructor(public payload: any) {}

      }
      export class InActivatePsSuccess implements Action {
        public readonly type = ESOActions.InActivatePsSuccess;
        constructor(public payload: any) {}

      }
      export class InActivatePsError implements Action {
        public readonly type = ESOActions.InActivatePsError;
        constructor(public payload: any) {}

      }
      export class GetSOsByCustomerId implements Action {
        public readonly type = ESOActions.GetSOsByCustomerId;
        constructor (public payload: any, public param: any){}
      }
      export class GetSOsByCustomerIdSuccess implements Action {
        public readonly type = ESOActions.GetSOsByCustomerIdSuccess;
        constructor (public payload: any){}
      }
      export class GetSOsByCustomerIdError implements Action {
        public readonly type = ESOActions.GetSOsByCustomerIdError;
        constructor (public payload: any){}
      }
      export class cancelDo implements Action {
        public readonly type = ESOActions.cancelDo;
        constructor (public payload: any){}
      }
      export class cancelDoSuccess implements Action {
        public readonly type = ESOActions.cancelDoSuccess;
        constructor (public payload: any){}
      }
      export class cancelDoError implements Action {
        public readonly type = ESOActions.cancelDoError;
        constructor (public payload: any){}
      }

export type SOAction =  GetAllSOs | GetAllSODetails | AddSO | EditSO | SetSOSuccess | SetSOError 
                        | AddDispatchOrder | GetSOCode | GetSOCodeSuccess | GetDONumber
                        | GetDONumberSuccess | GetDONumberError | AddDO | GetAddDOSuccess | GetAddDOError
                        | GetAllDOs| GetAllDOsSuccess| GetAllDOsError| GetDOdetails|GetDOdetailsSuccess| GetDOdetailsError|
                        AddPackSlips |GetAddPackSlipsSuccess|GetAddPackSlipsError |  GetAllPackSlips|  GetAllPackSlipsSuccess|
                        GetAllPackSlipsError|  EditpackSlips| GetEditpackSlipsSuccess|GetEditpackSlipsError | GetSOById | GetSOByIdSuccess
                        | GetSOByIdError | GetInActiveStatus| GetInActiveStatusSuccess|GetInActiveStatusError|
                        CloseSO|GetCloseSOSuccess|GetCloseSOError|GetRPsBasedOnMonth|GetRPsBasedOnMonthSuccess|
                        GetRPsBasedOnMonthError|GetForcastSales|GetForcastSalesSuccess|GetForcastSalesError|
                        AddForcastSales|GetaddForcastSalesSuccess|GetaddForcastSalesError|
                        EditForcastSales|GeteditForcastSalesSuccess|GeteditForcastSalesError|
                        GetDOsByPS|GetDOsByPSSuccess|GetDOsByPSError|GetDosByFormulaId|GetDosByFormulaIdSuccess
                        |GetDosByFormulaIdError |InActivatePs|InActivatePsSuccess|InActivatePsError|GetSOsByCustomerId|GetSOsByCustomerIdSuccess|GetSOsByCustomerIdError
                        |cancelDo|cancelDoSuccess|cancelDoError;
                        
                        